<template>
  <div class="form-sec form-sec--bundle-img form-body-part--bundle-img">
    <div class="mt-e-title-container">
      <MdTypography
        :data-qa-id="dataQaIdTitle"
        variant="heading7--regular"
        color="spirits--900"
        tag="h3"
      >
        {{ title }}
      </MdTypography>
      <MdTypography
        v-if="showOptionalText" 
        class="optional_span"
        variant="micro1--regular"
        color="spirits--700"
        tag="span"
      >
        {{ $t('pages.bundle.draft.optional_text') }}
      </MdTypography>
    </div>
    <MdTypography
      class="mt-e-para"
      variant="body2--regular"
      color="spirits--700"
      tag="p"
      v-html="sanitizeDescription(description)"
    />
    <div class="thingsToKeepInMind-div" @click="openThingstoKeepInMindModal">
      {{ $t('pages.bundle.draft.uploader.criteria.title') }}
    </div>

    <template v-if="imageUploadStatus !== 'unset'">
      <fou-group v-if="imageUploadStatus === ''">
        <span class="searchingMalwareIcon"></span>
        <MdTypography
          class="malwareText"
          variant="body2--medium"
          color="spirits--700"
          tag="span"
        >
          {{ $t('malwareScan.scanInitiationMessage') }}
        </MdTypography>
      </fou-group>
      
      <fou-group v-if="imageUploadStatus === 'true'">
        <span class="successMalwareIcon"></span>
        <MdTypography
          class="malwareText"
          variant="body2--medium"
          color="spirits--700"
          tag="span"
        >
          {{ $t('malwareScan.scanCompletionMessage') }}
        </MdTypography>
      </fou-group>
      
      <fou-group v-else-if="imageUploadStatus === 'false'">
        <span class="malwareIcon"></span>
        <MdTypography
          class="malwareText"
          variant="body2--medium"
          color="spirits--700"
          tag="span"
        >
          {{ $t('malwareScan.malwareDetectionMessage') }}
        </MdTypography>
      </fou-group> 
    </template>

    <div class="form-sec__content is-flex is-flex--align-center">
      <div class="form-sec__uploader">
        <FouUploader
          :id="uploaderId"
          class="image-uploader"
          :data-qa-id="uploaderId"
          :rules="rules"
          :priority="priority"
          :name="name"
          :errors="errors"
          :drag-text="dragText"
        />
      </div>
    </div>

    <div class="malwareFoundFilesContainer" :style="{'marginTop': images.length < 3 && priority === 1 ? '1.75rem' : '0.5rem'}" v-if="imageUploadStatus === 'false' && avCheckFalseFiles?.length">
      <span class="malwareFoundFilesContainer__text"> 
        <MdTypography
          variant="body2--regular"
          color="orange-squash--500"
          tag="span"
          v-html="$t('malwareScan.imageErrorMessageNew')"
        />
        <MdTypography
          variant="body2--regular"
          color="orange-squash--500"
          tag="span"
        >
          {{ avCheckFalseFiles.join('; ') }}
        </MdTypography>
      </span>
    </div> 

    <FouUploadedItem
      v-if="images.length>0"
      :id="thumbnailId"
      class="image-thumbnail"
      :data-qa-id="thumbnailId"
      :priority="priority"
      :images="images"
      :updateImagesSortOrder="updateImagesSortOrder"
    />
  </div>
</template>
<script src="./index.js" />
<style lang="scss">
@import 'mpl-css/lib/assets/global/variables/fonts';
@import 'mpl-css/lib/assets/global/variables/colors';
@import 'mpl-css/lib/assets/global/variables/breakpoints';
@import 'mpl-css/lib/assets/global/functions/index';
@import 'mpl-css/lib/assets/global/mfpfonts/fonts';
@import "mpl-css/lib/assets/global/icons/icons-colors";
@import 'mpl-css/lib/assets/global/icons/icons-svg';

.form-sec--bundle-img {

  .tablet-mobile {
    display: none;
  }

  .malwareIcon {
  background-image: url(map-get($icons,'malware-icon'));
  width: rem(16);
  height: rem(16);
  display: inline-block;
  background-size: contain;
  background-repeat: no-repeat;
  }

  .searchingMalwareIcon {
  background-image: url(map-get($icons,'searching-malware-icon'));
  width: rem(16);
  height: rem(16);
  display: inline-block;
  background-size: contain;
  background-repeat: no-repeat;
  }

  .successMalwareIcon {
    background-image: url(map-get($icons,'success-malware-icon'));
    width: rem(16);
    height: rem(16);
    display: inline-block;
    background-size: contain;
    background-repeat: no-repeat;
  }

  .malwareText {
    @extend .mfp-HelveticaNowMTText-Medium-13;
    text-align: left;
    padding: rem(4);
    color: map-get($colors, 'spirits-700')
  }

  .malwareFoundFilesContainer{
    display: flex;
    margin-top: 0.5rem;
    
    &__text{
      @extend .mfp-HelveticaNowMTText-Regular-13;
      text-align: left;
      color: map-get($colors, 'orange-squash')
    }
  }

  @media screen and (min-width: map-get($breakpoints, 'tab')) and (max-width: map-get($breakpoints, 'l'))  {
      .tablet-mobile {
        display: block;
      }
    }

    @media screen and (max-width: map-get($breakpoints, 's'))  {
      .tablet-mobile {
        display: block;
      }
    }

  .mt-link {
    color: map-get($colors, 'blue-duck--500');
    text-decoration: underline;
  }

  .form-sec__content  {
    gap: rem(24);
    margin-top: 0;

    @media screen and (max-width: map-get($breakpoints, 's'))  {
      flex-direction: row-reverse;
    }

    @media screen and (max-width: 576px)  {
      flex-direction: column-reverse;
    }

    .form-sec__uploader {
      width: 100%;

      @media screen and (max-width: map-get($breakpoints, 's'))  {
        width: 100%;
      }
    }

    .form-sec__criteria {
      padding: rem(24) rem(16);
      background-color: map-get($colors, 'blue-duck--25');
      border: 1px solid map-get($colors, 'blue-duck--200');
      border-radius: rem(16);
      width: rem(264);

      @media screen and (max-width: map-get($breakpoints, 's'))  {
        width: 100%;
      }

      .mt-e-title {
        font-size: rem(13);
        line-height: rem(16);
        margin-bottom: rem(11);
        color: map-get($colors, 'spirits--800');

      }

      .mt-list {
        color: map-get($colors, 'spirits--700');
        font-size: rem(13);
        line-height: rem(16);
        margin-left: rem(24);
        list-style-type: square;

        &__item {
          font-family: $mt-regular;

          &:not(:last-child) {
            margin-bottom: rem(12);

            @media screen and (max-width: map-get($breakpoints, 's'))  {
              margin-bottom: rem(8);
            }
          }

          &::marker {
            font-size: rem(8);
          }

          strong {
            font-family: $mt-medium;
            font-weight: 500;
          }
        }
      }
    }
  }

  .fou-uploader__content {

    .mt-e-para {
      font-size: rem(16);
      line-height: rem(24);
      color: map-get($colors, 'spirits--800');
      margin-top: rem(16);
      margin-bottom: 0;
    }
    }
  }

  .thingsToKeepInMind-div{
    @extend .mfp-HelveticaNowMTText-Medium-13;
    color: map-get($colors, 'blue-duck--500');
    padding: 0.5rem 0rem 2rem 0rem;
    @media screen and (min-width: map-get($breakpoints, 'tab')) {
      display: none;
    }
  }
.thingstoKeepModal{
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  background-color: map-get($colors, 'blue-duck--25');
  z-index: 999;
  padding: 1.5rem;
  border-radius: 1rem 1rem 0rem 0rem;
  background-color: map-get($colors, 'white');
}

</style>
